//
//
//
//

export default {
  prop: ['error'],
}
